/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

import { v4 as uuid } from 'uuid';

export const GODAVARI_DEVICE_ID_STORAGE_KEY = 'token';
const GODAVARI_DEVICE_ID_PATTERN = /^[0-9a-f]{32}-\d{13}$/;

/**
 * Creates a Godavari device id (`as-did`) in the SonyLIV format: a 32 character
 * UUID-v4 hex string without dashes, followed by `-<epoch millis>`.
 */
export function createGodavariDeviceId(now: number = Date.now()): string {
  return `${uuid().replace(/-/g, '')}-${now}`;
}

/**
 * Returns the persisted Godavari device id, creating and storing one on first use.
 * Falls back to an in-memory id when storage is unavailable (e.g. blocked cookies).
 */
export function getOrCreateGodavariDeviceId(storageKey: string = GODAVARI_DEVICE_ID_STORAGE_KEY): string {
  try {
    const existing = localStorage.getItem(storageKey);
    if (existing && GODAVARI_DEVICE_ID_PATTERN.test(existing)) return existing;
    const created = createGodavariDeviceId();
    localStorage.setItem(storageKey, created);
    return created;
  } catch {
    return createGodavariDeviceId();
  }
}
